export default __webpack_public_path__ + "static/media/logo1.2b32b1cf.png";